

















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'MastheadInput',

  props: {
    /**
     * Text added on input
     */
    value: {
      type: [String, Number, Object, Array],
      default: '',
    },
    /**
     * Maxlength of input
     */
    maxlength: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Text to be displayed on placeholder
     */
    placeholder: {
      type: String,
      required: true,
    },
    /**
     * Is input focused
     */
    isFocused: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    selectAllOnFocus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    internalValue: {
      get(): String | Number {
        return this.value
      },
      set(value: any): any {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    isFocused: {
      handler(newValue) {
        if (this.$refs.inputRef !== undefined && newValue) {
          // @ts-ignore
          this.$refs.inputRef.focus()
        }
      },
    },
  },

  mounted() {
    this.$el.addEventListener('keydown', (event: Event) => {
      // @ts-ignore
      this.submitOnEnter(event)
    })

    if (this.isFocused) {
      // @ts-ignore
      this.$refs.inputRef.focus()
    }
  },

  beforeDestroy() {
    this.$el.removeEventListener('keydown', (event: Event) => {
      // @ts-ignore
      this.submitOnEnter(event)
    })
  },

  methods: {
    submit() {
      this.$emit('blur')
      this.$emit('input-submitted', this.internalValue)
      // @ts-ignore
      this.$refs.inputRef.blur()
    },

    submitOnEnter(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.submit()
        event.preventDefault()
      }
    },
  },
})
